<ng-container *ngIf="visible">
  <div class="progress-spinner"
       [style.position]="position"
       [style.background]="background"
  >
    <div class="loader"></div>
  </div>
</ng-container>
